import { api } from "../../../../api/axios";

const controller = "Auth";
export async function LoginAsync(loginModel) {
  return await api.post(`/${controller}/Login`, loginModel, {
    withCredentials: true,
  });
}
